/**
 * Normaliza itens de GET /buscar_localidades para label + código de área (AREA_LOCAL).
 */

export function getAreaLocalFromLocalidade(item) {
  if (item == null) return ''

  const raw =
    typeof item === 'string'
      ? item
      : item.CN ??
        item.cn ??
        item.AREA_LOCAL ??
        item.area_local ??
        item.AreaLocal ??
        item.CODIGO_AREA ??
        item.codigo ??
        item.CODIGO

  if (raw == null || raw === '') return ''

  const digits = String(raw).replace(/\D/g, '')
  if (!digits) return ''
  if (digits.startsWith('0800')) return ''

  // Quando vier AREA_LOCAL (ex.: 31000), reduz para DDD e reconstrói.
  const ddd = digits.length >= 5 && digits.endsWith('000') ? digits.slice(0, 2) : digits
  if (ddd.length !== 2) return ''

  // Formato exigido pela API de busca: DDD + 000 (ex.: 31 => 31000).
  return `${ddd}000`
}

export function shouldIncludeLocalidade(item) {
  const areaLocal = getAreaLocalFromLocalidade(item)
  return !!areaLocal
}

export function getLocalidadeLabel(item) {
  const areaLocal = getAreaLocalFromLocalidade(item)
  if (!areaLocal) return 'DDD'
  return `DDD ${areaLocal.slice(0, 2)}`
}
